module.exports = __webpack_public_path__ + "static/media/brew-bnb.50ab7a8f.svg";